const jsonHeaders = (token) => ({
  "Content-Type": "application/json",
  "x-access-token": token,
});

export const fetchDeviceInfoCacheRequest = (serverUrl, token) =>
  fetch(`${serverUrl}/MDM/Fully/DeviceInfo/Cache`, {
    headers: jsonHeaders(token),
  });

export const fetchFoldersRequest = (serverUrl, token) =>
  fetch(`${serverUrl}/MDM/Folders`, {
    headers: jsonHeaders(token),
  });

export const fetchFolderAssignmentsRequest = (serverUrl, token) =>
  fetch(`${serverUrl}/MDM/Folders/Assignments`, {
    headers: jsonHeaders(token),
  });

export const sendDeviceCommandRequest = (serverUrl, endpoint, token, payload) =>
  fetch(`${serverUrl}${endpoint}`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

export const createFolderRequest = (serverUrl, token, payload) =>
  fetch(`${serverUrl}/MDM/Folders`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

export const deleteFolderRequest = (serverUrl, token, folderId) =>
  fetch(`${serverUrl}/MDM/Folders/${encodeURIComponent(String(folderId || "").trim())}`, {
    method: "DELETE",
    headers: {
      "x-access-token": token,
    },
  });

export const moveDevicesRequest = (serverUrl, token, payload) =>
  fetch(`${serverUrl}/MDM/Folders/MoveDevices`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

export const fetchFieldConfigRequest = (serverUrl, token) =>
  fetch(`${serverUrl}/MDM/Field/FetchConfig`, {
    headers: jsonHeaders(token),
  });

export const fetchMicromomentsRequest = (serverUrl, token, retailerId, storeId) =>
  fetch(
    `${serverUrl}/Micromoments/${encodeURIComponent(String(retailerId))}/${encodeURIComponent(String(storeId))}`,
    {
      headers: jsonHeaders(token),
    }
  );

export const restartFullyCacheRequest = (serverUrl, token) =>
  fetch(`${serverUrl}/MDM/Fully/RestartCache`, {
    headers: jsonHeaders(token),
  });

export const UPDATE_DEVICE_NOTES_ENDPOINT = "/MDM/Field/UpdateDeviceNotes";
export const UPDATE_MULTIPLE_DEVICE_NOTES_ENDPOINT = "/MDM/Field/UpdateMultipleDeviceNotes";

export const updateDeviceNotesRequest = (serverUrl, token, payload) =>
  fetch(`${serverUrl}${UPDATE_DEVICE_NOTES_ENDPOINT}`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

export const updateMultipleDeviceNotesRequest = (serverUrl, token, payload) =>
  fetch(`${serverUrl}${UPDATE_MULTIPLE_DEVICE_NOTES_ENDPOINT}`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });
